import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Banner } from "../../components";
import Section from "./Section";
import Form from "./Form";
import PageMeta from "../../seo/PageMeta";

const Contact = () => {
  const location = useLocation();
  const hasQuote = location.pathname.includes("quote");

  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
  }, [hasQuote]);

  return (
    <div className="flex flex-col items-center  w-full">
      <PageMeta
        title={hasQuote ? "Get a Free Quote" : "Contact Us"}
        description={
          hasQuote
            ? "Request a free cleaning quote from Clear Choice Cleaning Services in Melbourne, Australia. Fast response, no obligation."
            : "Get in touch with Clear Choice Cleaning Services for professional cleaning services across Melbourne, Australia."
        }
        path={location.pathname}
        image="/assets/images/banners/contact.webp"
      />
      <Banner
        page="contact"
        heading={hasQuote ? "Get a Free Quote" : "Contact Us"}
      />
      <Section />
      <Form />
    </div>
  );
};

export default Contact;
